module.exports = __webpack_public_path__ + "img/polgo-logotipo.03195271.svg";